module.exports = __webpack_public_path__ + "img/bf-logo-light.77966be7.png";